import React from 'react'
import PropTypes from 'prop-types'
import { Link as RouterLink } from 'react-router-dom'
import { Typography, Breadcrumbs, Link } from '@material-ui/core'
import styled from 'styled-components'
import { Icon } from '@iconify/react'
const StyledBreadcrumbs = styled(Breadcrumbs)`
  .MuiBreadcrumbs-separator {
    margin-left: 8px;
    margin-right: 8px;
  }
`

const StyledLink = styled(Link)`
  font-family: 'Inter';
  font-weight: 400;
  font-size: 14px;
  color: #637381;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`

const StyledTypography = styled(Typography)`
  font-family: 'Inter';
  font-weight: 400;
  font-size: 14px;
  color: #919eab;
  max-width: 300px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

const CoreBreadcrumb = ({
  links = [],
  activeLast = true,
  separator = <Icon icon="lucide:dot" width="24" height="24" />,
  ...props
}) => {
  const currentLink = links[links.length - 1]

  return (
    <StyledBreadcrumbs separator={separator} {...props}>
      {links.map((link, index) => {
        const isLast = index === links.length - 1

        return isLast && activeLast ? (
          <StyledTypography key={`breadcrumb-${index}`}>
            {link.name}
          </StyledTypography>
        ) : (
          <StyledLink
            key={`breadcrumb-${index}`}
            component={RouterLink}
            to={link.href}
            underline="none"
          >
            {link.name}
          </StyledLink>
        )
      })}
    </StyledBreadcrumbs>
  )
}

CoreBreadcrumb.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      href: PropTypes.string,
    }),
  ).isRequired,
  activeLast: PropTypes.bool,
  separator: PropTypes.node,
}

export default CoreBreadcrumb
